import HEADERS from 'constants/spotlight';
import pluralize from 'pluralize';

export const createSubUrl = (resource, params) => {
  if (resource === 'rules') {
    return `groups/${params.rule_group}/rules/${params.id}`;
  }

  if (resource === 'matching_pattern_elements') {
    return `groups/${params.rule.rule_group}/rules/${params.rule.id}`;
  }

  if (resource === 'rule_groups') {
    return `groups/${params.id}`;
  }

  if (resource === 'dictionary_columns') {
    return `dictionaries/${params.dictionary.id}`;
  }

  if (resource === 'entity_features') {
    return `entities/${params.entity}`;
  }

  if (resource === 'constraint_sets') {
    return `intents/${params.intent.id}`;
  }

  // default
  return `${resource}/${params.id}`;
};

export const getHeader = (resource, count) => ({
  header: HEADERS[resource].label,
  name: 'header',
  id: resource,
  icon: HEADERS[resource].icon,
  count,
});

export const getSecondaryInfoText = (resource, result) => {
  if (resource === 'dictionaries' && result.matched_tokens > 0) {
    return `(${result.matched_tokens} dictionary ${pluralize(
      'token',
      result.matched_tokens,
    )})`;
  }

  if (resource === 'constraint_sets') {
    let secondaryInfoText = '';
    const parenthesisContent = [
      {
        matchedNumber: result.matched_entities,
        singularName: 'entity',
        pluralName: 'entities',
      },
      {
        matchedNumber: result.matched_features,
        singularName: 'feature',
        pluralName: 'features',
      },
      {
        matchedNumber: result.matched_values,
        singularName: 'feature value',
        pluralName: 'feature values',
      },
    ]
      .reduce(
        (
          parenthesisContentChunks,
          { matchedNumber, singularName, pluralName },
        ) => {
          if (matchedNumber === 1) {
            parenthesisContentChunks.push(`${matchedNumber} ${singularName}`);
          }

          if (matchedNumber > 1) {
            parenthesisContentChunks.push(`${matchedNumber} ${pluralName}`);
          }
          return parenthesisContentChunks;
        },
        [],
      )
      .join(', ');

    secondaryInfoText += `(${parenthesisContent})`;
    return secondaryInfoText;
  }

  return '';
};
